import * as types from "../types";
import axios from "axios";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.token;

const API_TESTIMONIAL_LIST = types.API_BASE_URL + "testimonial/manage/list";
const API_TESTIMONIAL_NEW = types.API_BASE_URL + "testimonial/create";
const API_TESTIMONIAL_DETAIL = types.API_BASE_URL + "testimonial/manage/detail";
const API_TESTIMONIAL_UPDATE = types.API_BASE_URL + "testimonial/update";
const API_TESTIMONIAL_DELETE = types.API_BASE_URL + "testimonial/delete";

const state = {};

const getters = {};

const mutations = {};

const actions = {

  [types.GET_TESTIMONIAL_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_TESTIMONIAL_LIST, payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.SET_NEW_TESTIMONIAL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(API_TESTIMONIAL_NEW, payload, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.GET_TESTIMONIAL_DETAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_TESTIMONIAL_DETAIL + "/" + payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data[0]);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.UPDATE_TESTIMONIAL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(API_TESTIMONIAL_UPDATE, payload, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.DELETE_TESTIMONIAL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(API_TESTIMONIAL_DELETE, payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

};

export default {
  state,
  mutations,
  actions,
  getters
};
